var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./CommonHonoredListInner.jinja');
require('./CommonHonoredListInner.less');

module.exports = Base.extend({

    template: template,

    events: {
    },

    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'onResize');

        Base.prototype.initialize.call(this, options);
    },


    viewsRegistration: function () {
        Base.prototype.viewsRegistration.call(this);

        $(window).on('resize', this.onResize);

        this.onResize();
    },


    destroy: function () {
        $(window).off('resize', this.onResize);

        return Base.prototype.destroy.call(this);
    },


    onResize: function () {
        var prevTop;
        var $prevItems = $();
        var maxAspect = 0;
        var lines = [];
        var w = this.$('.CommonHonoredListInner-person')
            .eq(0)
            .width();

        this.$('.CommonHonoredListInner-person').each(function (ind, item) {
            var $item = $(item);
            var top = $item.position().top;

            //new line
            if (top != prevTop) {
                if (maxAspect > 0) {
                    lines.push({
                        $items: $prevItems,
                        maxAspect: maxAspect
                    });
                }

                $prevItems = $();
                maxAspect = 0;
            }

            maxAspect = Math.max(maxAspect, $item.find('.CommonHonoredListInner-personImageWrapper').attr('data-aspect') - 0);
            $prevItems = $prevItems.add($item);
            prevTop = top;
        });

        lines.push({
            $items: $prevItems,
            maxAspect: maxAspect
        });

        _.each(lines, function (line) {
            $(line.$items)
                .find('.CommonHonoredListInner-personImageWrapper')
                .each(function (indPrev, itemPrev) {
                    $(itemPrev).css({
                        'padding-top': w * line.maxAspect - w * ($(itemPrev).attr('data-aspect') - 0)
                    });
                });
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonHonoredList/CommonHonoredListInner.js
// module id = 159
// module chunks = 0